
let styles = {
  container: {
    padding: '5%',
    paddingTop: '1%',
    display: 'flex',
    justifyContent: 'center',
    display: 'flex',
    textAlign: 'center',
    float: 'center',
    flexDirection: 'column',
    marginTop: '4%',






  },

  heading2: {
    marginBottom: "15px",
  },

  published_style: {
    color: 'green',
    backgroundColor: '#d6e6d0',
    padding: '5px 8px',
    borderRadius: '5px',
  },

  unpublished_style: {
    color: 'red',
    backgroundColor: '#e6d0d0',
    padding: '5px 8px',
    borderRadius: '5px',
  },

  table: {

    borderStyle: 'outset',
    padding: '1%',
    width: '100%',
    marginLeft: '0%',
    marginTop: '10px'
  },
  items: {
    padding: '1%',
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '5%',
  },

  item_body: {
    padding: '6px ',
  },
  search_button: {
    backgroundColor: '#3CB3E2',
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    color: 'white'
  },
  tournment_empty: {
    minHeight: '200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    fontWeight: 'bold'
  },
  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#CD85F9',
    fontSize: '20px',
    textAlign: 'center',
  },

  input: {
    width: '90%',
    height: 25,
    backgroundColor: '#E9E1F9'
  },

  court_list: {
    padding: '1%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    borderBottom: '1px solid black',
  },
  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
    fontSize: '20px',
  },
  button_view: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '2%',
    fontSize: '22px',
  },
  input_button: {
    backgroundColor: '#21A6DB',
    color: 'white',
    borderRadius: '6px',
    marginBottom: '4px',
    marginTop: '4px',
  },
  body_div: {
    fontSize: '18px',
  },

  /* ===== Events Portal Styles (Appended) ===== */

  ep_events_col: {
    gridColumn: 'span 2 / span 2'
  },

  ep_events_card: {
    background: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    padding: '24px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
  },

  ep_events_title: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#0f172a',
    marginBottom: '16px'
  },

  ep_events_list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },

  ep_event_item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    background: '#f8fafc',
    borderRadius: '8px',
    transition: 'background 0.2s ease'
  },

  ep_event_main: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1
  },

  ep_event_date: {
    background: '#e0e7ff',
    color: '#4338ca',
    padding: '4px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 500
  },

  event_name_organiser_box: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },

  ep_event_name: {
    fontWeight: 600,
    color: '#0f172a'
  },

  ep_event_organizer: {
    fontSize: '14px',
    color: '#475569'
  },

  ep_event_entries: {
    background: '#4f46e5',
    color: '#ffffff',
    padding: '8px 16px',
    borderRadius: '999px',
    fontSize: '14px',
    fontWeight: 500
  },

  tournment_empty: {
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    fontWeight: 'bold'
  }


}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerTournament/style.js